import { Suspense, type PropsWithChildren } from 'react'

import Loader from '@space-lib/components/loader'
import ErrorBoundary from '@space-shell/common/components/errorBoundary'
import useGamificationToggle from '@space-shell/common/hooks/useGamificationToggle'
import useThemeContext from '@space-shell/common/hooks/useThemeContext'
import { BaseNames } from '@space-shell/core/router/constants'
import { useAuthStore, useMembershipStore, useUserInfoStore } from '@space-shell/core/store'
import { lazyRemote } from '@space-shell/lib/runtime'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'

export type GamificationProviderProps = PropsWithChildren<unknown>

const GamificationProviderMF = lazyRemote('gamification/GamificationProvider')

const GamificationProvider = ({ children }: GamificationProviderProps) => {
  const { id, token, authorities, userName, ucode } = useAuthStore()
  const { productId } = useParams<{ productId: string }>()
  const { membershipData, membershipSlug } = useMembershipStore()
  const { i18n } = useTranslation()
  const { avatar, email } = useUserInfoStore()
  const { data: isGamificationEnabled } = useGamificationToggle()
  const { theme } = useThemeContext()

  const basename = BaseNames.gamificatiton(membershipSlug, i18n.language.toLowerCase())

  return (
    <ErrorBoundary>
      <Suspense fallback={<Loader full />}>
        <GamificationProviderMF
          language={i18n.language}
          token={token}
          theme={theme}
          basename={basename}
          slug={membershipSlug}
          productId={productId || ''}
          clubName={membershipData?.name || ''}
          membershipId={membershipData?.id || ''}
          isGamificationEnabled={isGamificationEnabled || false}
          user={{
            id,
            name: userName,
            email: email || '',
            ucode,
            authorities,
            avatar
          }}>
          {children}
        </GamificationProviderMF>
      </Suspense>
    </ErrorBoundary>
  )
}

export default GamificationProvider
